import { connect } from 'react-redux';

import { PopularArticlesLayout } from 'components';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import {
  getSharedZonePopularAriclesList,
  getSharedZonePopularAriclestags,
  getPopularAriclesFramePerSlideRate,
} from 'store/SharedZone/selectors';

const mapStateToProps = (state) => ({
  isMobile: isScreenBelow640(state),
  articles: getSharedZonePopularAriclesList(state),
  tags: getSharedZonePopularAriclestags(state),
  framesPerSlide: getPopularAriclesFramePerSlideRate(state),
});

export default connect(mapStateToProps)(PopularArticlesLayout);
